import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App, { resetApp } from "./App";
import { watchShellHeight } from "./shellHeight";
import "./styles.css";

// Escape hatch for a client wedged by a stale service worker or cache, which is
// otherwise only fixable by deleting and reinstalling the app: /?reset=1
if (location.search.includes("reset")) {
  void resetApp();
} else {
  watchShellHeight();
  if ("serviceWorker" in navigator) {
    const hadController = Boolean(navigator.serviceWorker.controller);
    let reloaded = false;
    // A new worker calling skipWaiting + claim takes over a page that is still running
    // the previous build's JS. Reload once so page and assets come from one deploy.
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (!hadController || reloaded) return;
      reloaded = true;
      location.reload();
    });
    window.addEventListener("load", () => { void navigator.serviceWorker.register("/sw.js"); });
  }
  createRoot(document.getElementById("root")!).render(<StrictMode><App /></StrictMode>);
}
